// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { sortedPlaneListSelector } from '../../../selectors/planeSelectors';
import Planes from '../Planes';
import type { Props } from '../Planes';

const mapStateToProps = (state: State) => {
    return {
        planes: sortedPlaneListSelector(state)
    };
};

export default connect<Props, *, _, _, _, _>(mapStateToProps)(Planes);